import React, { useState, useEffect } from "react";
import { Auth, setLoggedOut } from "redux/features/auth";
import { useDispatch } from "react-redux";

import { usePortalContext } from "context";
import { useRawSetTitle } from "util/title";
import Login from "components/login";
import StaffLogin from "components/staffLogin";
import MainApp from "mainApp";
import { PersonSelectionPage } from "staffApp";

import "./App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
  useNavigationType,
} from "react-router-dom";
import { homepage } from "config";

function AuthProvider({ allowStaff, allowExternal }) {
  return (
    <Auth {...{ allowStaff, allowExternal }}>
      <Outlet />
    </Auth>
  );
}

function Unauthenticated() {
  useRawSetTitle("Login");
  const { loggedIn } = usePortalContext();

  // The first time we navigate to a login area, clear any previous
  // authentication ... don't navigate out again right away if already
  // authenticated!
  const [cleared, setCleared] = useState(!loggedIn);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!cleared) {
      dispatch(setLoggedOut());
      setCleared(true);
    }
  }, [cleared, dispatch, setCleared]);

  const success = cleared && loggedIn;
  const navigationType = useNavigationType();
  if (success) return <Navigate to={navigationType === "PUSH" ? -1 : ".."} />;
  else return <Outlet />;
}

function Authenticated() {
  const { loggedIn } = usePortalContext();
  if (loggedIn) return <Outlet />;
  else return <Navigate to="login" />;
}

function App() {
  return (
    <div className="App">
      <Router basename={homepage}>
        <Routes>
          <Route path="staff" element={<AuthProvider allowStaff />}>
            <Route element={<Unauthenticated />}>
              <Route path="login" element={<StaffLogin />} />
            </Route>

            <Route element={<Authenticated />}>
              <Route path="for/:personId/*" element={<MainApp />} />
              <Route index element={<PersonSelectionPage />} />
              <Route path="*" element={<Navigate to="" replace />} />
            </Route>
          </Route>
          <Route path="*" element={<AuthProvider allowExternal />}>
            <Route element={<Unauthenticated />}>
              <Route path="login" element={<Login />} />
            </Route>
            <Route element={<Authenticated />}>
              <Route path="*" element={<MainApp />} />
            </Route>
          </Route>
        </Routes>

        <div className="development-banner">
          <div className="development-wording">
            <b>Development instance.</b> Test data is in use; real data will be
            unaffected.
          </div>
        </div>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
